import React from "react";
import { TabType } from "../../../../shared/enums";
import EditStore from "./components/edit-store";
import { ProductCategoryModel, StoreModel } from "../../../../../redux/reducers/static-data.reducers";
import EditProductCategory from "./components/edit-product-category";
import { ProvinceModel } from "../../../../../pages/shared/models/provinceModel";
import EditProvince from "./components/edit-province";
import EditCity from "./components/edit-city";
import { CityModel } from "../../../../../pages/shared/models/cityModel";
import { RegionModel } from "../../../../../pages/shared/models/regionModel";
import EditRegion from "./components/edit-region";
import EditBlog from "./components/edit-blog";
import { BlogPostModel } from "../../../../../pages/shared/models/blogModel";
import EditOnlineStores from "./components/edit-online-stores";
import { OnlineStoresModel } from "../../../../../pages/shared/models/onlineStoresModel";
import EditOnlineStoreCategory from "./components/edit-online-store-category";
import { CategoryModel } from "../../../../../pages/shared/models/CategoryModel";
import EditBlogCategory from "./components/edit-blog-category";

const EditStaticData = ({ onCancel, staticDataDialogProps }: EditStaticDataDialogProps) => {
    if (staticDataDialogProps) {
        switch (staticDataDialogProps.type) {
            case TabType.STORE:
                return <EditStore storeData={staticDataDialogProps.staticData as StoreModel}
                    onCancel={() => onCancel()} />
            case TabType.PRODUCT_CATEGORY:
                return <EditProductCategory productCategoryData={staticDataDialogProps.staticData as ProductCategoryModel}
                    onCancel={() => onCancel()} />
            case TabType.PROVINCE:
                return <EditProvince provinceData={staticDataDialogProps.staticData as ProvinceModel}
                    onCancel={() => onCancel()} />
            case TabType.CITY:
                return <EditCity cityData={staticDataDialogProps.staticData as CityModel}
                    onCancel={() => onCancel()} />
            case TabType.REGION:
                return <EditRegion regionData={staticDataDialogProps.staticData as RegionModel}
                    onCancel={() => onCancel()} />
            case TabType.BLOG:
                return <EditBlog blogData={staticDataDialogProps.staticData as BlogPostModel}
                    onCancel={() => onCancel()} />
            case TabType.BLOG_CATEGORY:
                return <EditBlogCategory category={staticDataDialogProps.staticData as CategoryModel}
                    onCancel={() => onCancel()} />
            case TabType.ONLINE_STORES:
                return <EditOnlineStores onlineStores={staticDataDialogProps.staticData as OnlineStoresModel}
                    onCancel={() => onCancel()} />
            case TabType.ONLINE_STORE_CATEGORY:
                return <EditOnlineStoreCategory category={staticDataDialogProps.staticData as CategoryModel}
                    onCancel={() => onCancel()} />
        }
    }
    return <></>
}

interface EditStaticDataDialogProps {
    onCancel: () => void,
    staticDataDialogProps?: StaticDataDialogProps
}

export interface StaticDataDialogProps {
    type?: TabType,
    staticData: any
}

export default EditStaticData;